import React from 'react';

import { loadBusinessPartners } from 'scenes/Gallery/GalleryPage/Creatives/sources/fields';
import ShareForm from 'scenes/Gallery/components/ShareForm';

import { useIsUpdating, useUpdate, useShare } from './data';

const ShareCreativeForm = ({ id, name, onSubmit, onClose, onExited, open }) => {
  const { data, isLoading } = useShare(id);
  const isUpdating = useIsUpdating();
  const [updateShare] = useUpdate();

  const handleSubmit = async (values) => {
    await updateShare({ ...values, id });
    onSubmit();
  };

  return (
    <ShareForm
      title={'Share Creative'}
      entityId={id}
      subTitle={name}
      initialValues={data}
      active={!!data}
      source={loadBusinessPartners}
      loading={isLoading || isUpdating}
      onClose={onClose}
      onExited={onExited}
      onSubmit={handleSubmit}
      open={open}
    />
  );
};

export default ShareCreativeForm;
